<template>
  <div class="left-box">
    <p class="title" v-if="p != undefined">{{ p }}</p>
    <div class="left-box-box">
         <div class="l-b-t" v-if="navtype == 'two'">
          <li
            v-for="(item, index) in navleft"
            :key="index"
            @click="toggle(item.type,index)"
            :class="currentIndex == index ?'active':''"
            ><span>{{ item.title }}</span
            ><span>></span></li
          >
        </div>
      <div class="l-b-t" v-if="navtype == 'three'">
        <router-link
          v-for="(item, index) in navleft"
          :key="index"
          :to="item.url"
          tag="li"
          ><span>{{ item.title }}</span
          ><span>></span></router-link
        >
        </div>
        <div class="l-b-t" v-if="navtype == 'four'">
         <li
            v-for="(item, index) in navleft"
            :key="index"
            :class="currentIndex == item.id ?'active':''"
            @click="getnewsId(item.id)"
            ><span>{{ item.name }}</span
            ><span>></span></li
          >
        </div>
      <div class="l-b-b">
        <div class="phone">
          <p>电话订购</p>
          <span>400-088-0777</span>
        </div>
        <div class="wechat">
          <div class="img">
            <img src="../images/1.jpg" alt="" />
          </div>
          <p>【扫一扫，微信订购】</p>
        </div>
        <div class="email">
          <p>邮件订购：</p>
          <span>订购邮箱 <br>sales_me@bioleaper.com</span>
          <span>服务邮箱<br> service_me@bioleaper.com</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AncyVue from '../Ancy.vue';
export default {
  data(){
    return{
      currentIndex:0
    }
  },
  props: {
    navleft: {
    },
    navtype: {
    },
    p:{
    }
  },
  methods: {
    toggle(type,index){
      this.currentIndex = index
      this.$emit('fromChild', type)
    },
    getnewsId(id){
      this.currentIndex = id
      this.$emit('fromChild', id)
    }
  },
  created() {
    if(this.$route.query.id){
      this.getnewsId(this.$route.query.id)
    }
    else{
      this.getnewsId(1)
    }
    if(this.$route.query.type &&  this.$route.query.index){
      let type = this.$route.query.type
      let index = this.$route.query.index
      this.toggle(type,index)
    }else{
      this.toggle('fukuan',0)
    }
  },
};
</script>

<style lang="less" scoped>
.left-box {
  width: 313px;
  background: #003871;
  margin-top: 44px;
  margin-bottom: 20px;
  .title {
    width: 100%;
    height: 80px;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    padding-top: 25px;
    padding-left: 30px;
  }
  .left-box-box {
    width: 300px;
    .l-b-t {
      width: 300px;
      background: #fbfbfb;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .active{
        color: #A52A2A;
      }
      span {
        cursor: pointer;
      }
      li {
        font-size: 14px;
        width: 100%;
        height: 50px;
        font-weight: 700;
        color: #666666;
        line-height: 50px;
        position: relative;
        span{
          position: absolute;
          &:nth-child(1){
            left:50px
          }
          &:nth-child(2){
            right:50px
          }
        }
        &.router-link-exact-active {
          color: #A52A2A;
        }
      }
    }
    .l-b-b {
      opacity: 0.89;
      background: #fafbfc;
      min-width: 300px;
      min-height: 450px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      .phone {
        font-size: 16px;
        text-align: center;
        color: #333333;
        line-height: 36px;
        font-weight: bold;
        span{
          font-size: 22px;
        }
      }
      .wechat {
        .img {
          margin: auto;
          width: 134px;
          height: 134px;
          background: #ffffff;
          img {
            width: 118px;
            height: 118px;
            background: rgba(0, 0, 0, 0);
          }
        }
        p {
          font-weight: bold;
          font-size: 16px;
          color: #333333;
        }
      }
      .email {
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        p {
          font-weight: bold;
          font-size: 15px;
          text-align: center;
          color: #000;
        }
        span {
          font-size:15px;
          color: #000;
          margin-top: 13px;
        }
      }
    }
  }
}
</style>